import React, { FC } from 'react';
import NavigationLink from 'src/shared-components/NavigationLink/NavigationLink';
import {
  receivingNewBookingsAllPharmacies,
  bookingStatusUpdate,
  cancelledOrder
} from 'src/utils/links';
import cn from 'classnames';

const sharedParagraphClassnames = ' before:-ml-4 before:text-astronautBlue-500';
const listStyle = "before:content-['•']";

const Process: FC = () => {
  return (
    <div>
      <ul className="indent-6">
        <li>
          <span
            className={cn("before:content-['1.']", sharedParagraphClassnames)}
          >
            Після створення замовлення, йому надається статус NEW
          </span>
        </li>
        <li>
          У партнера є 20 хвилин, щоб викачати нове замовлення за допомогою API
        </li>
        <li>
          <span className="fs-body-bold">GET</span>
          <NavigationLink
            passClassName="underline "
            href={receivingNewBookingsAllPharmacies}
          >
            {receivingNewBookingsAllPharmacies}
          </NavigationLink>
        </li>
        <li>
          <span
            className={cn("before:content-['2.']", sharedParagraphClassnames)}
          >
            Після отримання аптекою замовлення необхідно оновити статус
            замовлення на RECEIVED за допомогою API
          </span>
        </li>
        <li>
          <span className="fs-body-bold">POST</span>
          <NavigationLink passClassName="underline " href={bookingStatusUpdate}>
            {bookingStatusUpdate}
          </NavigationLink>
        </li>
        <li>
          Цей крок також допоможе не отримувати дублікати замовлень, якщо ви
          запитуєте API нових замовлень декілька разів.
        </li>
        <li>
          <span
            className={cn("before:content-['3.']", sharedParagraphClassnames)}
          >
            У аптеки є година на обробку замовлення
          </span>
        </li>
        <li>
          Наступні можливі статуси:
          <ul className="indent-12">
            <li>
              <span className={cn(listStyle, sharedParagraphClassnames)}>
                APPROVED - аптека підтвердила замовлення
              </span>
            </li>
            <li>
              <span className={cn(listStyle, sharedParagraphClassnames)}>
                CANCELED - аптека скасувала замовлення
              </span>
            </li>
          </ul>
        </li>
        <li>Оновити стутус можна за допомогою API</li>
        <li>
          <span className="fs-body-bold">POST</span>
          <NavigationLink passClassName="underline " href={bookingStatusUpdate}>
            {bookingStatusUpdate}
          </NavigationLink>
        </li>
        <li>
          <span
            className={cn("before:content-['4.']", sharedParagraphClassnames)}
          >
            Ми бронюємо товар на 72 години.
          </span>
        </li>
        <li>
          <span
            className={cn("before:content-['5.']", sharedParagraphClassnames)}
          >
            Якщо клієнт оплатив і забрав замовлення, необхідно оновити статус
            замовлення на PAID.
          </span>
        </li>
        <li>
          Якщо клієнт відмовився від замовлення, треба надіслати CANCELED
          статус.
        </li>
        <li>
          <span
            className={cn("before:content-['6.']", sharedParagraphClassnames)}
          >
            Якщо замовлення буде скасовано по таймінгу або клієнт скасує його
            самостійно, йому буде надано статус CANCELED_BY_LIKIE
          </span>
        </li>
        <li>
          Для того, щоб отримувати замовлення скасовані клієнтом необхідно
          використовувати API
        </li>
        <li>
          <span className="fs-body-bold">GET</span>
          <NavigationLink passClassName="underline " href={cancelledOrder}>
            {cancelledOrder}
          </NavigationLink>
        </li>
        <li>
          Щоб не отримувати скасовані клієнтом замовлення повторно, їх можно
          перевести у статус CANCEL_APPROVED.
        </li>
        <li>
          За бажанням ви можете відмічати скасовані замовлення як оплачені
          (наприклад якщо кліент забрав замовлення після 72 годин), але не можна
          відміняти вже оплачені замовлення.
        </li>
      </ul>
    </div>
  );
};

export default Process;
